<template>
  <div class="flex-1 overflow-y-auto bg-lightGray rounded-lg w-full">
    <router-view :key="`${podId}-${route.params.userId || 'main'}`" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const podId = computed(() => route.params.id as string)
</script>
